module.exports = __webpack_public_path__ + "img/com_SECO.6ebd16b4.jpg";